var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalAtm = function SvgLocalAtm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M8.75 12.25h1.5v-1h1.115a.86.86 0 0 0 .631-.254q.254-.255.254-.63V7.634a.86.86 0 0 0-.254-.631.86.86 0 0 0-.63-.254H8.25v-1.5h4v-1.5h-2v-1h-1.5v1H7.635a.86.86 0 0 0-.631.254.86.86 0 0 0-.254.63v2.731q0 .378.254.631.255.255.63.254h3.116v1.5h-4v1.5h2zM1.808 15q-.758 0-1.283-.525A1.75 1.75 0 0 1 0 13.192V1.808Q0 1.05.525.525T1.808 0h15.384q.758 0 1.283.525T19 1.808v11.384q0 .758-.525 1.283T17.192 15zm0-1.5h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V1.808a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H1.808a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.384q0 .116.096.212a.3.3 0 0 0 .212.096"
  })));
};
export default SvgLocalAtm;